module.exports = __webpack_public_path__ + "img/mvt_miningvoxelt.63cafee.png";